// Pure helpers for the Receipt Processing page. Kept side-effect free so they
// can be reused by the review panel + recent list without dragging React in.

export function fmtCurrency(val) {
  const num = Number(val);
  if (!Number.isFinite(num)) return '';
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(num);
}

export function fmtDate(iso) {
  if (!iso) return '';
  try {
    return new Date(iso).toLocaleString(undefined, {
      month: 'short', day: 'numeric', year: 'numeric',
      hour: 'numeric', minute: '2-digit',
    });
  } catch {
    return '';
  }
}

// If user edits qty or unit_price, auto-update line_total. If they edit
// line_total directly and qty is set, derive unit_price.
export function recalcTotal(row, keyChanged) {
  const qty = Number(row.quantity) || 0;
  const unit = Number(row.unit_price) || 0;
  const total = Number(row.line_total) || 0;
  if (keyChanged === 'quantity' || keyChanged === 'unit_price') {
    return { ...row, line_total: +(qty * unit).toFixed(2) };
  }
  if (keyChanged === 'line_total' && qty > 0) {
    return { ...row, unit_price: +(total / qty).toFixed(2) };
  }
  return row;
}

// Build the per-line tax/ship/final distribution map. Tax always splits
// proportionally to line_total. Shipping follows the chosen mode.
export function computeDistributions({ items, taxNum, shipNum, shippingMode, shippingItemId, subtotal }) {
  const n = items.length;
  const out = items.reduce((m, it) => {
    m[it.id] = { tax: 0, ship: 0, final: Number(it.line_total) || 0 };
    return m;
  }, {});

  if (taxNum > 0 && subtotal > 0) {
    for (const it of items) {
      out[it.id].tax = ((Number(it.line_total) || 0) / subtotal) * taxNum;
    }
  }

  if (shipNum > 0 && n > 0) {
    if (shippingMode === 'proportional' && subtotal > 0) {
      for (const it of items) {
        out[it.id].ship = ((Number(it.line_total) || 0) / subtotal) * shipNum;
      }
    } else if (shippingMode === 'equal') {
      const each = shipNum / n;
      for (const it of items) out[it.id].ship = each;
    } else if (shippingMode === 'assigned') {
      if (shippingItemId && out[shippingItemId]) out[shippingItemId].ship = shipNum;
    }
  }

  for (const it of items) {
    const d = out[it.id];
    d.final = (Number(it.line_total) || 0) + d.tax + d.ship;
  }
  return out;
}
